var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 31,
    viewBox: "0 0 29 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1183_1374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9096 19.8991C29.1313 20.1875 28.9204 20.5989 28.5509 20.5989H21.6002V29.347C21.6002 29.9508 21.0981 30.4405 20.4792 30.4405C19.8602 30.4405 19.3581 29.9508 19.3581 29.347V20.5989H12.4075C12.0379 20.5989 11.827 20.1875 12.0487 19.8991L15.9949 14.7669H12.5931C12.1936 14.7669 11.9936 14.2957 12.2761 14.0203L17.4896 8.93487H14.2373C13.8614 8.93487 13.6523 8.51059 13.8871 8.22423L19.8955 0.898313C20.1947 0.533519 20.7635 0.533519 21.0627 0.898313L27.0712 8.22409C27.306 8.51044 27.0971 8.93472 26.721 8.93472H23.4687L28.6823 14.0201C28.9648 14.2957 28.7648 14.7668 28.3652 14.7668H24.9634L28.9096 19.8991ZM7.40001 20.5989V29.347C7.40001 29.9508 7.9021 30.4405 8.52108 30.4405C9.14006 30.4405 9.64215 29.9508 9.64215 29.347V22.1011C9.53602 21.9566 9.41614 21.824 9.33273 21.6611C9.1574 21.3194 9.06143 20.9608 9.01674 20.5989C8.89925 19.744 9.10568 18.867 9.65814 18.1485L10.5296 17.0144C10.0478 16.662 9.65964 16.1837 9.41734 15.6147C8.88311 14.3582 9.17354 12.9237 10.1589 11.9605L11.5559 10.5993C11.3939 10.4021 11.2538 10.1842 11.1384 9.94935C10.5604 8.77609 10.7194 7.41708 11.5544 6.40114L12.5861 5.14302L9.10463 0.898313C8.80538 0.533519 8.23662 0.533519 7.93737 0.898313L1.92903 8.22423C1.69421 8.51059 1.90317 8.93487 2.27926 8.93487H5.53156L0.317981 14.0203C0.0354708 14.2958 0.23547 14.7669 0.635019 14.7669H4.0368L0.090478 19.8991C-0.131195 20.1875 0.0797157 20.5989 0.44922 20.5989H7.40001Z",
    fill: "#2D5A1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1183_1374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29.8157,
    fill: "white",
    transform: "translate(0 0.624718)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree);
export default __webpack_public_path__ + "static/media/tree.bb048a2b5a8859c6110a83ee6bba534c.svg";
export { ForwardRef as ReactComponent };